import React from 'react'
import PropTypes from 'prop-types'

import PageTitle from '/components/common/PageTitle'
import DefaultLayout from '/components/layouts/DefaultLayout'
import BlankLayout from '/components/layouts/BlankLayout'
import services from '/components/services'
import { APIURL } from '/constants'
import { pageRender } from '/components/theme/default'

const Page = ({ slug, page }) => {
  return (
    <div>
      <PageTitle
        title={`${page.name || ''}`}
        description={`${page.meta_description || ''}`}
      />
      <div
        className="home-wrapper component-library"
        style={{ paddingTop: '80px' }}
      >
        {pageRender(page)}
      </div>
    </div>
  )
}

Page.getLayout = function getLayout(pageProps) {
  const layout = pageProps?.page?.layout || 'default'
  if (layout === 'blank') {
    return BlankLayout
  }
  return DefaultLayout
}

Page.propTypes = {
  slug: PropTypes.string,
  page: PropTypes.object
}

export async function getServerSideProps(ctx) {
  const { slug } = ctx.query
  const { host } = ctx.req.headers
  const res = await services.get_v2(APIURL.API_PAGE_DATA(slug), {}, host)
  if (res.statusCode !== 200) {
    return {
      notFound: true
    }
  }
  const page = res.response
  return {
    props: {
      slug,
      page
    }
  }
}

export default Page
